import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Population } from './population.model';

export interface PopulationState extends EntityState<Population> {}

/**
 * @deprecated PopulationStore no longer used as population data is not being kept in stores
 * - Population data should come from the user's JWT and accessible via the MemberQuery
 * - Retained for backwards compatibility
 */
@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'population', idKey: 'PopulationId' })
export class PopulationStore extends EntityStore<PopulationState> {
  constructor() {
    super();
  }
}
